import { useQuery } from "@tanstack/react-query";
import { getSupabaseWithLogging } from "@/lib/hooks/api/utils";

export function useTaskNotes(taskId: string) {
  return useQuery({
    queryKey: ["task-notes", taskId],
    queryFn: async () => {
      const supabase = getSupabaseWithLogging();
      const { data, error } = await supabase
        .from("task_notes")
        .select(
          `
          *,
          user:app_users!task_notes_user_id_fkey(
            id,
            first_name,
            last_name,
            email
          )
        `
        )
        .eq("task_id", taskId)
        .order("created_at", { ascending: false });

      if (error) {
        console.error("Error fetching task notes:", error);
        throw new Error(error.message);
      }

      return data || [];
    },
    enabled: !!taskId,
  });
}
